export default {
  updateDealerInfo(state, data) {
    if (!data) {
      return
    }
    Object.assign(state.user.userInfo.dealer, data)
  },
}
